<template>
  <li class="list-item"><slot /></li>
</template>

<style lang="scss" scoped>
.list-item {
  margin-top: 1rem;
}
</style>
